export const formatCurrency = number => {
  return new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND' }).format(number);
};

export const formatNumber = number => {
  return new Intl.NumberFormat('vi-VN').format(number);
};

// Group the integer part with dots and keep any fraction behind a comma, vi-VN style.
export const currencyFormatter = value => {
  if (value) {
    const [integer, fraction] = `${value}`.split('.');
    const grouped = integer.replace(/\B(?=(\d{3})+(?!\d))/g, '.');

    return fraction ? `${grouped},${fraction}` : grouped;
  }

  return value;
};

// Vietnamese grouping: dot thousands, comma decimals; tolerates decimal strings from the API
export const currencyFormatterDisplay = value => {
  if (value == null) return '—';

  const number = Number(value);

  return Number.isNaN(number) ? `${value}` : formatNumber(number);
};

export const formatPrice = num => {
  const currency = Intl.NumberFormat('vi-VN', {
    style: 'currency',
    currency: 'VND',
    minimumFractionDigits: 0,
  });

  if (num) {
    return currency.format(num);
  }

  return num;
};

// Đơn giá carries fractions of a đồng whenever a supplier prices per smaller unit,
// and dropping them makes SL × Đơn giá disagree with the invoice's Thành tiền.
export const formatUnitPrice = num => {
  const number = Number(num);

  if (!Number.isFinite(number)) return num;

  return Intl.NumberFormat('vi-VN', {
    style: 'currency',
    currency: 'VND',
    maximumFractionDigits: 4,
  }).format(number);
};

export const currencyParser = value => {
  return `${value ?? ''}`.replace(/[^\d,-]/g, '').replace(',', '.');
};

export const getAddressDetail = ({ address, ward, city }) => {
  const addressDetail = [];

  if (address) {
    addressDetail.push(address);
  }

  const wardName = ward ? ward.name : '';

  if (wardName) {
    addressDetail.push(wardName);
  }

  const cityName = city ? city.name : '';

  if (cityName) {
    addressDetail.push(cityName);
  }

  return addressDetail.length > 0 ? addressDetail.join(', ') : '';
};

// Fold Vietnamese diacritics (and đ/Đ) so "bom" matches "Bơm".
export const foldVietnamese = value =>
  String(value ?? '')
    .normalize('NFD')
    .replace(/\p{M}/gu, '')
    .replace(/đ/g, 'd')
    .replace(/Đ/g, 'D')
    .toLowerCase();

// Accent-insensitive filterOption for antd Selects that filter client-side.
export const accentInsensitiveFilterOption = (input, option) =>
  foldVietnamese(option?.label ?? option?.children ?? option?.searchText ?? '').includes(foldVietnamese(input).trim());
